import BlogContent from './BlogContent';

export default BlogContent;
